import _get from 'lodash/get';
import { filterAllowedLandingResources } from 'components/HeroLanding/utils/filterResources';
import { parseClientExcludedUtils } from 'components/Hooks/useClientExcludedResourceType';

export function mergeLandingInfo(items, itemsWithResources, clientDetails) {
  const {
    isResourceTypeExcluded,
    isTopicExcluded,
    isTopicExcludedById,
    isAssessmentExcluded,
  } = parseClientExcludedUtils(clientDetails);

  return Array.from({ length: items.length }, (_, i) => {
    const featuredCollageCollection = {
      items: filterAllowedLandingResources(
        _get(itemsWithResources[i], 'featuredCollageCollection.items'),
        clientDetails,
        [
          _get(clientDetails, 'sys.id'),
          _get(clientDetails, 'clientGroup.sys.id'),
        ],
        {
          isResourceTypeExcluded,
          isTopicExcluded,
          isTopicExcludedById,
          isAssessmentExcluded,
        },
      ),
      __typename: 'LandingFeaturedCollageCollection',
    };
    const featuredResourcesCollection = {
      items: filterAllowedLandingResources(
        _get(itemsWithResources[i], 'featuredResourcesCollection.items'),
        clientDetails,
        [
          _get(clientDetails, 'sys.id'),
          _get(clientDetails, 'clientGroup.sys.id'),
        ],
        {
          isResourceTypeExcluded,
          isTopicExcluded,
          isTopicExcludedById,
          isAssessmentExcluded,
        },
      ),
      __typename: 'LandingFeaturedResourcesCollection',
    };

    return {
      ...items[i],
      featuredCollageCollection,
      featuredResourcesCollection,
    };
  });
}
